import { Collapse, ConfigProvider } from "antd";
import type { CollapseProps } from "antd";
import { useState } from "react";
import { IconType } from "react-icons/lib";

export const EditWithAI = (label: string, BtnIcon: IconType, content: any) => {
  const [isOpen, setIsOpen] = useState(false);

  const items: CollapseProps["items"] = [
    {
      key: "1",
      label: (
        <div className="flex text-[15px] font-bold content-center text-center">
          <BtnIcon
            color={isOpen ? "black" : "gray"}
            size={20}
            className="mr-2 flex self-center"
          />
          {label}
        </div>
      ),
      children: content
    }
  ];

  return (
    <ConfigProvider
      theme={{
        components: {
          Collapse: {
            contentBg: "#f7f8fc"
          },
          Input: {
            activeBorderColor: "#A5ACC1",
            hoverBorderColor: "#A5ACC1",
            activeShadow: "none"
          },
          Button: {
            defaultHoverBorderColor: "#A5ACC1",
            defaultHoverColor: "inherit"
          }
        }
      }}
    >
      <Collapse
        items={items}
        expandIconPosition="end"
        style={{ backgroundColor: isOpen ? "#f7f8fc" : "white" }}
        onChange={(e) => {
          e.length > 0 ? setIsOpen(true) : setIsOpen(false);
        }}
        defaultActiveKey={[]}
      />
    </ConfigProvider>
  );
};
